import { render, staticRenderFns } from "./swiftConfigure.vue?vue&type=template&id=c4aef83a&scoped=true&"
import script from "./swiftConfigure.vue?vue&type=script&lang=js&"
export * from "./swiftConfigure.vue?vue&type=script&lang=js&"
import style0 from "./swiftConfigure.vue?vue&type=style&index=0&id=c4aef83a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4aef83a",
  null
  
)

export default component.exports